<template>
    <ubi-panel v-if="hasMultiAccounts && !isSubUser">

        <el-container>
            <el-aside width="25%">
                <h3>{{ $t("posts.edit.adManagerTitle") }}</h3>
                <p class="text-justify" v-html="$t('posts.edit.adManagerText')"></p>
            </el-aside>
            <el-container style="width: 100%;">
                <el-main>
                    <el-col :span="24">
                        <el-form-item :label="$t('posts.edit.user')">
                            <!--                                    <el-input v-model="post.contact_a_afficher"/>-->
                            <el-select
                                    clearable
                                    v-model="selectedUser"
                                    @change="userChanged"
                            >
                                <el-option
                                        style="text-transform:capitalize"
                                        v-for="user in this.users"
                                        :key="user.id"
                                        :value="user.id"
                                        :label="user.fullname + ' - ' + user.username"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-main>
            </el-container>
        </el-container>
    </ubi-panel>
</template>

<script>
import { getUsers } from '@/services/users'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'PostFormAttachedUser',
  props: ['post', 'idUser'],
  data () {
    return {
      users: [],
      selectedUser: null
    }
  },
  computed: {
    ...mapGetters(['isSubUser', 'hasMultiAccounts']),
    ...mapState('postEditImmo', ['adManagerChanged'])
  },
  watch: {
    adManagerChanged: function () {
      this.loadUser()
    },
    post () {
      if (this.post.user_data_code && this.post.user_data_value) {
        this.selectedUser = this.users.find(x => (x.identifierCode == this.post.user_data_code) && (x.identifierValue == this.post.user_data_value)).id
      }
    }
  },
  async mounted () {
    this.users = (await getUsers({ active: true, pagination: false, roles: '!ROLE_CONTACT' })).list
    if (this.post.user_data_code && this.post.user_data_value) {
      this.selectedUser = this.users.find(x => (x.identifierCode == this.post.user_data_code) && (x.identifierValue == this.post.user_data_value)).id
    }
  },
  methods: {
    userChanged (id) {
      const user = this.users.find(x => x.id === id)
      if (user) {
        this.post.user_data_code = user.identifierCode
        this.post.user_data_value = user.identifierValue
        if (this.post.user_data_code && this.post.user_data_value) {
          this.post.user_data_change = true
          this.post.user_data_id = id
        }
      }
    },
    async loadUser () {
      this.users = (await getUsers({ active: true, pagination: false, roles: '!ROLE_CONTACT' })).list
      if (this.post.user_data_code && this.post.user_data_value) {
        this.selectedUser = this.users.find(x => x.identifierCode == this.post.user_data_code && x.identifierValue == this.post.user_data_value).id
      }
    }
  },
  async created () {

  }
}
</script>

<style scoped>

</style>
